'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _get = require('lodash/get');
var constants = require('./constants.js');
var funders = require('./funders.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);

function getOverrideStatus(transaction, defaultStatus) {
  var status = defaultStatus;

  if (funders.isMedicare(_get__default["default"](transaction, 'claims[0].funder.code'))) {
    var isClaimRejected = _get__default["default"](transaction, 'claims[0].status') === constants.TRANSACTION_STATUSES.REJECTED;
    var isTransactionCompleted = transaction.status === constants.TRANSACTION_STATUSES.COMPLETED;

    var hasMedicareErrored = _get__default["default"](transaction, 'medicare.hasFatalError');

    if (isClaimRejected && isTransactionCompleted && !hasMedicareErrored) {
      status = constants.TRANSACTION_STATUSES.UNDER_REVIEW;
    }

    var isClaimPending = _get__default["default"](transaction, 'claims[0].status') === constants.TRANSACTION_STATUSES.PENDING && transaction.status !== constants.TRANSACTION_STATUSES.CANCELLED;

    if (isClaimPending) {
      status = constants.TRANSACTION_STATUSES.PENDING;
    }
  }

  if (funders.isIcare(_get__default["default"](transaction, 'claims[0].funder.code')) && _get__default["default"](transaction, '_schemaVersion') === '2') {
    var _isClaimPending = _get__default["default"](transaction, 'status') === constants.TRANSACTION_STATUSES.PENDING;

    if (_isClaimPending) {
      status = constants.TRANSACTION_STATUSES.SUBMITTED;
    }
  }

  return status;
}

exports.getOverrideStatus = getOverrideStatus;
